import AuthService from '@/api/AuthService'
import UserService from '@/api/UserService'
import LocalStorage from '@/utils/LocalStorage'
import UtilService from '../../../utils/UtilService'
const state = {
  user: {},
  jwt: '',
  userConfig: {},
  userOverview: {},
  userStatSale: {},
  userStatRole: {},
  userMaxout: {},
  totalPps: {},
  searchUserCode: '',
  userStats: 0,
  userKyc: {}
}

const getters = {
  user: state => state.user,
  jwt: state => state.jwt,
  userConfig: state => state.userConfig,
  userOverview: state => state.userOverview,
  userStatRole: state => state.userStatRole,
  userStatSale: state => state.userStatSale,
  userMaxout: state => state.userMaxout,
  totalPps: state => state.totalPps,
  searchUserCode: state => state.searchUserCode,
  userStats: state => state.userStats,
  userKyc: state => state.userKyc
}

const mutations = {
  SET_USER_KYC: (state, data) => {
    state.userKyc = data
  },
  SET_USER_STATS: (state, data) => {
    state.userStats = data
  },
  SET_USER_CODE: (state, data) => {
    state.searchUserCode = data
  },
  SET_USER_PPS: (state, data) => {
    state.totalPps = data
  },
  SET_USER_CONFIG: (state, data) => {
    state.userConfig = data
  },
  SET_USER: (state, user) => {
    state.user = user
  },
  SET_JWT: (state, jwt) => {
    state.jwt = jwt
  },
  SET_USER_MAXOUT: (state, data) => {
    state.userMaxout = data
  },
  SET_USER_OVERVIEW: (state, data) => {
    state.userOverview = data
  },
  SET_USER_STAT_ROLE: (state, data) => {
    state.userStatRole = data
  },
  SET_USER_STAT_SALE: (state, data) => {
    state.userStatSale = data
  }
}

const actions = {
  setUserCode ({ commit }, data) {
    commit('SET_USER_CODE', data)
  },
  setJwt ({ commit }, data) {
    commit('SET_JWT', data)
  },
  getUser ({ commit }) {
    if (!LocalStorage.getToken()) return
    this.dispatch('setJwt', LocalStorage.getToken())
    UserService.getUser().then(rs => {
      const isSuccess = rs.status
      isSuccess && commit('SET_USER', rs.data)
    })
  },
  async getUserStaticalSale ({ commit }) {
    const res = await UserService.getUserStaticalSale()
    const data = UtilService.transformStaticalSale(res.data)
    if (res.status) commit('SET_USER_STAT_SALE', data)
  },
  async getUserStats ({ commit }, params) {
    const res = await UserService.getUserStats(params)
    if (res.status) commit('SET_USER_STATS', res.data)
  },
  async getUserStaticalRole ({ commit }) {
    const res = await UserService.getUserStaticalRole()
    if (res.status) commit('SET_USER_STAT_ROLE', res.data)
  },
  getUserOverview ({ commit }) {
    UserService.getUserOverview().then(rs => {
      const isSuccess = rs.status
      isSuccess && commit('SET_USER_OVERVIEW', UtilService.transformUserOverview(rs.data))
    })
  },
  getUserMaxout ({ commit }) {
    UserService.getUserMaxout().then(rs => {
      const isSuccess = rs.status
      isSuccess && commit('SET_USER_MAXOUT', UtilService.transformUserMaxout(rs.data))
    })
  },
  getTotalPPS ({ commit }) {
    UserService.getTotalPps().then(rs => {
      const isSuccess = rs.status
      isSuccess && commit('SET_USER_PPS', UtilService.transformUserPPS(rs.data))
    })
  },
  async getEstimateBuy ({ commit }, data) {
    const res = await UserService.getEstimateBuy(data)
    return res
  },
  getUserConfig ({ commit }, symbol) {
    UserService.getUserConfig(symbol).then(rs => {
      const isSuccess = rs.status
      console.log(rs.data)
      isSuccess && commit('SET_USER_CONFIG', rs.data)
    })
  },
  async changeMatrix (__, data) {
    return await UserService.changeUserMatrix(data)
  },
  async uploadUserKyc (__, data) {
    return await UserService.uploadUserKyc(data)
  },
  async getUserKyc ({ commit }, data) {
    const result = await UserService.getUserKyc(data)
    const kycData = result.data
    // kycData.kycStatus = 'REJECTED'
    // kycData.fullname = 'Frankie'
    // kycData.idNumber = '123123'
    // kycData.dob = '699814800000'
    // kycData.nationalId = 'VNM'
    kycData.type = kycData.kycType
    kycData.dobTxt = UtilService.convertTsToDate(kycData.kycDob)
    commit('SET_USER_KYC', kycData)
    return kycData
  },
  verifyEmail ({ commit }, code) {
    return new Promise((resolve, reject) => {
      AuthService.verifyEmail(code).then(rs => {
        const isSuccess = rs.status
        resolve(isSuccess)
      }).catch(e => {
        reject(e)
      })
    })
  },
  resendVerifyEmail ({ commit }, data) {
    return new Promise((resolve, reject) => {
      AuthService.resendVerifyEmail(data).then(rs => {
        const isSuccess = rs.status
        resolve(isSuccess)
      }).catch(e => {
        reject(e)
      })
    })
  },
  forgotPassword ({ commit }, data) {
    return new Promise((resolve, reject) => {
      AuthService.forgotPassword(data).then(rs => {
        const isSuccess = rs.status
        resolve(isSuccess)
      }).catch(e => {
        reject(e)
      })
    })
  },
  request2FA ({ commit }, data) {
    return new Promise((resolve, reject) => {
      UserService.request2FA(data).then(rs => {
        resolve(rs)
      }).catch(e => {
        reject(e)
      })
    })
  },
  enable2FA ({ commit }, data) {
    return new Promise((resolve, reject) => {
      UserService.enable2FA(data).then(rs => {
        const isSuccess = rs.status
        resolve(isSuccess)
      }).catch(e => {
        reject(e)
      })
    })
  },
  disable2FA ({ commit }, data) {
    return new Promise((resolve, reject) => {
      UserService.disable2FA(data).then(rs => {
        const isSuccess = rs.status
        resolve(isSuccess)
      }).catch(e => {
        reject(e)
      })
    })
  },
  sendEmailCode ({ commit }) {
    return new Promise((resolve, reject) => {
      UserService.sendEmailCode().then(rs => {
        resolve(rs)
      }).catch(e => {
        reject(e)
      })
    })
  },
  resetPassword ({ commit }, data) {
    return new Promise((resolve, reject) => {
      AuthService.resetPassword(data).then(rs => {
        const isSuccess = rs.status
        resolve(isSuccess)
      }).catch(e => {
        reject(e)
      })
    })
  },
  forgotOTP ({ commit }, data) {
    return new Promise((resolve, reject) => {
      AuthService.forgotOTP(data).then(rs => {
        const isSuccess = rs.status
        resolve(isSuccess)
      }).catch(e => {
        reject(e)
      })
    })
  },
  removeOTP ({ commit }, data) {
    return new Promise((resolve, reject) => {
      AuthService.removeOTP(data).then(rs => {
        const isSuccess = rs.status
        resolve(isSuccess)
      }).catch(e => {
        reject(e)
      })
    })
  },
  login ({ commit }, data) {
    return new Promise((resolve, reject) => {
      AuthService.login(data).then(rs => {
        const isSuccess = rs.status
        isSuccess && LocalStorage.setToken(rs.data) && commit('SET_JWT', rs.data)
        isSuccess && this.dispatch('setJwt', rs.data)
        resolve(rs)
      }).catch(e => {
        reject(e)
      })
    })
  },
  register (__, data) {
    return new Promise((resolve, reject) => {
      AuthService.register(data).then(rs => {
        resolve(rs.status)
      }).catch(e => {
        reject(e)
      })
    })
  },
  changePassword (__, data) {
    return new Promise((resolve, reject) => {
      UserService.changePassword(data).then(rs => {
        resolve(rs.status)
      }).catch(e => {
        reject(e)
      })
    })
  }
}

export default { state, getters, mutations, actions }
